<template>
  <b-modal id="modal-success" hide-footer centered>
    <div class="col-12 d-flex flex-column align-items-center">
      <img
        class="centerImg1"
        src="@/assets/images/icons/checkbox-circle-line.svg"
      />
      <h2 class="pt-5 font-weight-bold">¡Proceso exitoso!</h2>
      <label
        class="pb-2 table-value"
        style="
          color: #455a64;
          margin-bottom: 16px;
          text-align: center;
          margin-top: 10px;
        "
        >{{ messageModal }}</label
      >
      <OkayModal @click="$bvModal.hide('modal-success')"> Entendido </OkayModal>
    </div>
  </b-modal>
</template>

<script>
import OkayModal from "@/components/core/button/okay-modal.vue";

export default {
  components: {
    OkayModal
  },
  props: {
    messageModal: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped></style>
